import { createRuntimeOperationType, isRuntimeOperationConfig } from './common';
export const fallbackOperationType = createRuntimeOperationType({
    kind: 'FALLBACK',
    dependencies: () => [],
    run: (value, context) => {
        if (!Array.isArray(value)) {
            throw new Error(`FALLBACK value must be an array. Got ${JSON.stringify(value)}`);
        }
        if (value.some(isRuntimeOperationConfig)) {
            return value;
        }
        return value.find(item => item !== null && item !== undefined);
    },
});
//# sourceMappingURL=fallback.js.map